import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from '@/i18n'
import '@/sass/overrides.sass'

import { DEFAULT_PALETTE, DARK_DEFAULT_PALETTE } from '@/lib/colors.js'

Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
  theme: {
    themes: {
      light: DEFAULT_PALETTE,
      dark: DARK_DEFAULT_PALETTE,
    },
  },
})
